// Pages
import { ActivityTeacherSubmissions } from "./activity-teacher-submissions.page";

export default ActivityTeacherSubmissions;
